import React from 'react'
import styles from './index.module.css'

const CategorySkeleton = () => {
    return (
        <div
            className={styles.category_btn_wrapper}
        >
            <div className={styles.category_image + " skeleton"} />
            <div className={styles.category_title + " skeleton"} />
        </div>
    )
}

export default CategorySkeleton